import { action, observable, makeObservable } from "mobx";

class OrganizerStore {
  filtersTaskList = null;

  filtersMap = null;

  defaultFolderFilters = null;

  constructor() {
    makeObservable(this, {
      filtersTaskList: observable,
      filtersMap: observable,
      defaultFolderFilters: observable,
      setFiltersTaskList: action,
      setFiltersMap: action,
      setDefaultFolderFilters: action,
    });
  }

  setFiltersTaskList(filters) {
    this.filtersTaskList = filters;
  }

  setFiltersMap(filters) {
    this.filtersMap = filters;
  }

  setDefaultFolderFilters(params) {
    this.defaultFolderFilters = params;
  }
}

export const organizerStore = new OrganizerStore();